
<template>
  <div id="app">
    <router-view style="height:inherit"/>
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style >
  #app{
    background: transparent;
    height: 100%;
  }
  html{
    min-width: 1200px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue